import { Component, OnInit } from '@angular/core';
import { FileType, GlobalFunctions, GlobalFunctionsGui } from 'globales-projekt-angular';
import { FileAppMetaDatas } from 'src/app/data/anwendung/FileAppMetaDatas.model';
import { ConstantsSonstige } from 'src/app/immutable/constants-sonstige';
import { DateiTyp } from 'src/app/immutable/enums/datei-typ';
import { ApiService } from 'src/app/services/api.service';
import { LocalService } from 'src/app/services/local.service';

@Component({
  selector: 'app-hilfe',
  templateUrl: './hilfe.component.html',
  styleUrls: ['./hilfe.component.css']
})
export class HilfeComponent implements OnInit {

  fileAppMetaDatas: FileAppMetaDatas = new FileAppMetaDatas(this.localService, this.apiService);

  constructor(private localService: LocalService, private apiService: ApiService) { }

  ngOnInit(): void {

    this.fileAppMetaDatas.loadFileAppMetaDatas();
  }

  downloadFileVdiAuszugPdf() {
    this.downloadFile(
      this.fileAppMetaDatas.vdiAuszugPdf.type,
      DateiTyp.VDI_AUSZUG_PDF,
      ConstantsSonstige.FILENAME_VDI_AUSZUG_PDF,
      this.fileAppMetaDatas.vdiAuszugPdf.endung
    );
  }

  downloadFile(
    type: FileType,
    dateiTyp: DateiTyp,
    fileName: string,
    fileEndung: FileType
  ) {


    this.localService.mainComponentRef.value?.waitingForDataSpinner(true);
    this.apiService
      .getAppFileDocuments(dateiTyp)
      .subscribe(async (response) => {
        GlobalFunctions.downloadFile(type, response, fileName, fileEndung);
        this.localService.mainComponentRef.value?.waitingForDataSpinner(false);
      });
  }

  onClickUp() {
    GlobalFunctionsGui.clickUp();
  }

  onClickDown() {
    GlobalFunctionsGui.clickDown();
  }

}
